import { useFeatureFlag } from '@crehana/feature-flags/react';

export const useHideBannerDownloadApp = () => {
  const { flagValue: shouldHideBannerDownloadAppCrehana, loading: isLoading } =
    useFeatureFlag('LEARNING_HIDE_BANNER_DOWNLOAD_APP');

  const hideBannerDownloadAppCrehana =
    !isLoading && shouldHideBannerDownloadAppCrehana;

  return { hideBannerDownloadAppCrehana };
};
